import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { IconButton } from 'material-ui';
import ArrowDropDown from 'material-ui/svg-icons/navigation/arrow-drop-down';
import ArrowDropUp from 'material-ui/svg-icons/navigation/arrow-drop-up';
import Delete from 'material-ui/svg-icons/action/delete';
import { StyleSheet, css } from 'aphrodite';

import * as InquiryActions from '../../store/actions/InquiryActions';

@connect()
export default class TravelerListItem extends React.Component {
  static propTypes = {
    index: PropTypes.number.isRequired,
    traveler: PropTypes.shape().isRequired,
    dispatch: PropTypes.func.isRequired,
  }

  moveUp = () => {
    const { dispatch, index } = this.props;
    dispatch(InquiryActions.moveTraveler(index, index - 1));
  }

  moveDown = () => {
    const { dispatch, index } = this.props;
    dispatch(InquiryActions.moveTraveler(index, index + 1));
  }

  remove = () => {
    const { dispatch, index } = this.props;
    dispatch(InquiryActions.removeTraveler(index));
  }

  render() {
    const { traveler: { fullName, displayName, birthdate, isAdult } } = this.props;
    const name = displayName || fullName;

    let age;
    if (birthdate) {
      age = moment().diff(moment(birthdate), 'years');
    } else {
      age = isAdult ? '18+' : 'child';
    }

    return (<li className={css(styles.listItem)}>
      <div>{name} ({age})</div>
      <div>
        <IconButton className={css(styles.buttonStyle)} onTouchTap={this.moveUp}>
          <ArrowDropUp />
        </IconButton>
        <IconButton className={css(styles.buttonStyle)} onTouchTap={this.moveDown}>
          <ArrowDropDown />
        </IconButton>
        <IconButton className={css(styles.buttonStyle)} onTouchTap={this.remove}>
          <Delete />
        </IconButton>
      </div>
    </li>);
  }
}

const styles = StyleSheet.create({
  listItem: {
    width: 300,
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
  },
  buttonStyle: {
    height: 24,
    width: 24,
    padding: 0,
    position: 'relative',
    top: 5,
    marginRight: 5,
  },
});



// WEBPACK FOOTER //
// /src/components/Inquiry/TravelerListItem.js